import { defineStore } from "pinia";
const useMultiLoginStore = defineStore("multilogin", {
  state: () => ({
    isSalesPerson: false,
    salesRepId: null,
    salesRelations: null,
    currentSalesRelation: null
  }),
  actions: {
    reset() {
      this.isSalesPerson = false;
      this.salesRepId = null;
      this.salesRelations = null;
      this.currentSalesRelation = null;
    }
  }
});
export {
  useMultiLoginStore
};
